/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { Component } from 'react'
import { inject } from "mobx-react";
import { Accordion, Badge, Grid } from '@scuf/common';
import IGatewayListProps from './IGatewayListProps';
import DIYAppConstants from "../../../utils/DIYAppConstants";
import './GatewayList.scss';
import IdentityPackage from "../../wizard/GatewayRegistration/IdentityPackage"
import { Progress } from "@scuf/common";
import GatewayManagementUtil from '../../../utils/GatewayManagementUtil';
import GatewayIdentityStore from '../../../stores/GatewayManager/GatewayIdentityStore';
import featureFlagStore from '../../../utils/FeatureFlags/APFeatureFlagsStore';
import { AxiosResponse } from 'axios';

export interface IGatewayListState {
    gatewayList: Gateway[];
    isLoaded: boolean;
}

@inject(DIYAppConstants.GATEWAY_IDENTITY_STORE)
export class GatewayList extends Component<IGatewayListProps, IGatewayListState>
{
    gatewayIdentityStore: GatewayIdentityStore;
    siteId: any;


    constructor(props: IGatewayListProps) {
        super(props);
        this.gatewayIdentityStore = props.gatewayIdentityStore!;
        this.siteId = props.siteId;
        this.state = {
            gatewayList: [],
            isLoaded: false
        }

        this.setGatewayCsrUploadStatus = this.setGatewayCsrUploadStatus.bind(this);
        this.setGatewaySerialNumber = this.setGatewaySerialNumber.bind(this);
    }

    componentDidMount() {
        //Function call to fetch gateway list by siteId
        this.fetchGatewayList(this.siteId);
    }
    componentWillReceiveProps(props: IGatewayListProps) {
        this.fetchGatewayList(props.siteId)
    }

    /**
     * Function which invokes an API to fetch Gateway list for the site
     */
    fetchGatewayList = async (siteId: any) => {
        this.setState({ isLoaded: false, gatewayList:[] });
        await featureFlagStore.updateLaunchDarklyFlag(siteId);
        var result: Gateway[] = [];
        var updatedResult: Gateway[] = [];


        await this.gatewayIdentityStore!.getGatewayListBySiteId(siteId).then(async (response: any) => {
            if (response && response.status == 200 && response.data) {

                if (response.data.data)
                    result = response.data.data;

                
                //Only Registration Pending gateways should appear in the list
                if (result) {
                    result.forEach(gateway => {
                        if (gateway.state && (gateway.state.toUpperCase() === 'PENDING' || gateway.state === 'REGISTRATION_PENDING')) {
                            updatedResult.push(gateway);
                        }
                    })
                }

                
                if (featureFlagStore.getSimplyConnectEnabled) {
                    try {
                        await this.updateCsrStatus(updatedResult);
                    } catch (error) {
                    }
                }

                updatedResult.forEach((gateway) => {
                    if (gateway.providerName === DIYAppConstants.PROVIDER_NAME_AZURE) {
                        gateway.type = gateway.gatewayType;
                    } else {
                        if(featureFlagStore.getGatewayAzureProvisioningForSite){
                            gateway.type = gateway.gatewayType;
                        }    
                        gateway.gatewayName = gateway.name ? gateway.name : gateway.gatewayName;
                    }
                });


                this.setState({ isLoaded: true, gatewayList: updatedResult });
            }
            else
                this.setState({ isLoaded: true, gatewayList: updatedResult });
        }).catch((error: any) => {
            this.setState({ isLoaded: true, gatewayList: updatedResult });
        })
    }
    /**
     * Function to check if CSR is uploaded or not
     * @param gatewayList list of Gateway(s) to be checked for CSR upload status
     */
    updateCsrStatus = async (gatewayList: Gateway[]): Promise<any> => {

        if (gatewayList === undefined || gatewayList.length == 0)
            return Promise.resolve(false);

        var ids: string[] = [];

        gatewayList.forEach((gateway) => {
            if (gateway.providerName !== DIYAppConstants.PROVIDER_NAME_AZURE) {
                let systemId = window.envVariables.SIMPLYCONNECT_SYSTEM_ID;
                ids.push(systemId + '-' + gateway.serial_number);
            }
        });

        return this.gatewayIdentityStore.getSimplyConnectClients(ids, this.siteId)
            .then((res: AxiosResponse) => {
                if (res != null && res.status == 200 && res.data != null) {
                    this.gatewayIdentityStore.simplyConnectCallSuccess = true;
                    var clients: any[] = res.data.object;

                    clients.forEach((client) => {
                        gatewayList.forEach((gateway) => {
                            if (gateway.serial_number == client.deviceId)
                                gateway.csr_uploaded = true;
                        });
                    });
                }
            });
    }

    render() {
        return (
            <div className="gateway-list-wrapper">
                {!this.state.isLoaded ?
                    (
                        <div>
                            <div className="gateway-list-loader">
                                <Progress circular={true}></Progress>
                            </div>
                            <div className="gw-loader-msg">Please wait while we search the site</div>
                        </div>
                    ) :
                    <div>
                        <div className="text-wrapper">
                            {this.state.gatewayList && this.state.gatewayList.length > 0 ? <span>We found the following gateways associated with the selected site</span> : <span>No Gateways</span>}
                        </div>
                        <div className="gateway-list">
                            <Accordion>
                                {
                                    this.state.gatewayList.map((gateway) =>
                                    (
                                        <Accordion.Content
                                            key={gateway.serial_number}
                                            title={this.generateGatewayTitle(gateway)}
                                            arrowPosition="right"
                                            className="accordion-list-item">
                                            <Grid className="accordion-gw-item">
                                                <Grid.Row>
                                                    <Grid.Column width={6}>
                                                        <div>
                                                            {gateway.serial_number ?
                                                            <div>
                                                                <Grid.Row>
                                                                    <Grid.Column width={12} className="identity-info-label">
                                                                        <div className="text-style">Serial No.</div>
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                                <Grid.Row>
                                                                    <Grid.Column width={12}>
                                                                        <div>{gateway.serial_number}</div>
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                            </div> : ''}
                                                            {gateway.type ?
                                                            <div>    
                                                                <Grid.Row>
                                                                    <Grid.Column width={12} className="identity-info-label">
                                                                        <div className="text-style">Gateway Type</div>
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                                <Grid.Row>
                                                                    <Grid.Column width={12}>
                                                                        <div>{gateway.type === "OTS" ? DIYAppConstants.HONEYWELL_CERTIFIED : gateway.type}</div>
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                            </div> : ''}   
                                                        </div>

                                                        <Grid.Row>
                                                            <Grid.Column width={12} className="grid-column-max-height">
                                                                <div>
                                                                    <span style={{ paddingRight: '5px' }}>
                                                                        <Badge color={GatewayManagementUtil.getColorForGatewayStatus(gateway.state)} empty />
                                                                    </span>
                                                                    {GatewayManagementUtil.getLabelForGatewayStatus(gateway.state)}
                                                                </div>
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    </Grid.Column>
                                                    {this.checkIfIdentityButtonsShouldBeDisplayed(gateway) ? (this.checkFeatureCompatibility(gateway) ?
                                                        <Grid.Column width={6} className='identity-action-grp'>
                                                            {this.renderDownloadContent(gateway)}
                                                            {this.renderCopyContent(gateway)}
                                                            {this.renderUploadContent(gateway)}
                                                            {this.renderReUploadContent(gateway)}
                                                            {this.renderUploadConfigContent(gateway)}
                                                            {this.renderReUploadConfigContent(gateway)}
                                                        </Grid.Column>
                                                        : <Grid.Column width={6} className='identity-action-grp'>
                                                            <span><span className='error-message'>No Action Allowed</span><br/>
                                                            Please disable the Simply Connect Feature Flag</span>
                                                        </Grid.Column>) : ''}

                                                </Grid.Row>
                                            </Grid>
                                        </Accordion.Content>
                                    ))
                                }
                            </Accordion>
                        </div>
                    </div>
                }
            </div>
        )
    }

    checkIfIdentityButtonsShouldBeDisplayed = (gateway: Gateway): boolean => {
        //Identity buttons should not be displayed if Simply Connect Feature is enabled and Simply Connect Call failed for non azure gateways
        let status = false;
        if (gateway) {
            if (gateway.providerName !== DIYAppConstants.PROVIDER_NAME_AZURE && featureFlagStore.getSimplyConnectEnabled && !this.gatewayIdentityStore.simplyConnectCallSuccess) {
                status = false;
                return status;
            }
            if (gateway.state && (gateway.state.toUpperCase() === 'REGISTRATION_PENDING' || gateway.state.toUpperCase() === 'PENDING')) {
                status = true;
            }
        }
        return status;
    }

    generateGatewayTitle = (gateway: Gateway) => {
        let title = '';
        if (gateway.serial_number) {
            title = title + gateway.serial_number + '-'
        }
        if (gateway.gatewayName) {
            title = title + gateway.gatewayName;
        }
        return title;
    }

    /**
     * Function that renders DOWNLOAD button
     */
    renderDownloadContent(gateway: Gateway) {
        if (this.checkIfAzureConfigUploaded(gateway) || this.checkIfSimplyConnectCSRUploaded(gateway) || this.checkIfPelionGateway(gateway)) {
            return (
                <Grid.Row>
                    <Grid.Column width={12}>
                        <IdentityPackage type='download' organizationId={this.siteId} serialNumber={gateway.serial_number} gatewayType={gateway.type} gateway={gateway} />
                    </Grid.Column>
                </Grid.Row>
            );
        }
    }
    /**
     * Function that renders COPY button
     */
    renderCopyContent(gateway: Gateway) {
        if (this.checkIfAzureConfigUploaded(gateway) || this.checkIfSimplyConnectCSRUploaded(gateway) || this.checkIfPelionGateway(gateway)) {
            return (
                <Grid.Row>
                    <Grid.Column width={12}>
                        <IdentityPackage type='copy' organizationId={this.siteId} serialNumber={gateway.serial_number} gatewayType={gateway.type} gateway={gateway} />
                    </Grid.Column>
                </Grid.Row>
            );
        }
    }
    /**
     * Function that renders UPLOAD button
     */
    renderUploadContent(gateway: Gateway) {
        if (featureFlagStore.getSimplyConnectEnabled) {
            if (!this.checkIfSimplyConnectCSRUploaded(gateway)) {
                return (
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <IdentityPackage type='upload' organizationId={this.siteId} serialNumber={gateway.serial_number} setGatewayCsr={this.setGatewayCsrUploadStatus} gateway={gateway} />
                        </Grid.Column>
                    </Grid.Row>
                );
            }
        }
    }

    /**
         * Function that renders UPLOAD Config button
         */
    renderUploadConfigContent(gateway: Gateway) {
        if (gateway.providerName === DIYAppConstants.PROVIDER_NAME_AZURE) {
            if (!this.checkIfAzureConfigUploaded(gateway)) {
                return (
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <IdentityPackage type='upload-config' organizationId={this.siteId} serialNumber={gateway.serial_number} setGatewayCsr={this.setGatewayCsrUploadStatus} setGatewaySerialNumber={this.setGatewaySerialNumber} gateway={gateway} />
                        </Grid.Column>
                    </Grid.Row>
                );
            }
        }
    }


    /**
     * Function that renders RE-UPLOAD button
     */
    renderReUploadContent(gateway: Gateway) {
        if (featureFlagStore.getSimplyConnectEnabled) {
            if (this.checkIfSimplyConnectCSRUploaded(gateway)) {
                return (
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <IdentityPackage type='re-upload' organizationId={this.siteId} serialNumber={gateway.serial_number} setGatewayCsr={this.setGatewayCsrUploadStatus} gateway={gateway} />
                        </Grid.Column>
                    </Grid.Row>
                );
            }
        }
    }

    /**
     * Function that renders RE-UPLOAD Config button
     */
    renderReUploadConfigContent(gateway: Gateway) {
        if (gateway.providerName === DIYAppConstants.PROVIDER_NAME_AZURE) {
            if (this.checkIfAzureConfigUploaded(gateway)) {
                return (
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <IdentityPackage type='re-upload-config' organizationId={this.siteId} serialNumber={gateway.serial_number} setGatewayCsr={this.setGatewayCsrUploadStatus} setGatewaySerialNumber={this.setGatewaySerialNumber} gateway={gateway} />
                        </Grid.Column>
                    </Grid.Row>
                );
            }
        }
    }

    /**
     * Once CSR content is uploaded,
     *   - This function will be invoked from IdentityPackage
     * 
     * In this function
     *   - corresponding Gateway.csr_uploaded will be updated
     *     (i.e.,) this.setState will be called.
     * 
     * so that UPLOAD button will be replaced with RE-UPLOAD button.
     */
    setGatewayCsrUploadStatus(id: string, csrUploaded: boolean, providerName: string, uploadedConfig: any) {
        if (providerName === DIYAppConstants.PROVIDER_NAME_AZURE) {
            var gateway = this.state.gatewayList.find((g) => g.gatewayId == id);

            if (gateway) {
                gateway.gatewayConfig = uploadedConfig;
                this.setState({ gatewayList: this.state.gatewayList });
            }
        } else {
            var gateway = this.state.gatewayList.find((g) => g.serial_number == id);

            if (gateway) {
                gateway.csr_uploaded = csrUploaded;
                this.setState({ gatewayList: this.state.gatewayList });
            }
        }

    }

    setGatewaySerialNumber(id: string, serialNumber:string) {
        if(serialNumber){
            var gateway = this.state.gatewayList.find((g) => g.gatewayId == id);
            if (gateway) {
                gateway.serial_number = serialNumber;
                this.setState({ gatewayList: this.state.gatewayList });
            }
        }
    }

    checkFeatureCompatibility = (gateway: Gateway): boolean => {
        //Simply Connect with Azure is not supported
        if ((featureFlagStore.getSimplyConnectEnabled && gateway.providerName === DIYAppConstants.PROVIDER_NAME_AZURE)) {
            return false;
        } else {
            return true;
        }
    }

    checkIfAzureConfigUploaded = (gateway: Gateway): boolean => {
        if ((gateway.type === 'VIRTUAL' || gateway.type === 'OTS') && gateway.providerName === DIYAppConstants.PROVIDER_NAME_AZURE && gateway.gatewayConfig != undefined) {
            return true;
        } else {
            return false;
        }
    }

    checkIfSimplyConnectCSRUploaded = (gateway: Gateway): boolean => {
        if (gateway.type === 'VIRTUAL' && featureFlagStore.getSimplyConnectEnabled && gateway.csr_uploaded) {
            return true;
        } else {
            return false;
        }
    }

    checkIfPelionGateway = (gateway: Gateway): boolean => {
        if (!featureFlagStore.getSimplyConnectEnabled && gateway.providerName !== DIYAppConstants.PROVIDER_NAME_AZURE) {
            return true;
        } else {
            return false;
        }
    }


}

export default GatewayList

export class Gateway {
    serial_number!: string;
    gatewayName!: string;
    state!: string;
    type?: string;
    csr_uploaded: boolean = false;
    gatewayConfig?: string;
    providerName?: string;
    gatewayType?: string;
    gatewayId?: string;
    customerId?: string;
    name!: string;
}